import { createContext, useContext } from 'react';

interface DateContextType {
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (date: Date | null) => void;
    setEndDate: (date: Date | null) => void;
    setDates: (start: Date | null, end: Date | null) => void;
    clearDates: () => void;
}

export const DateContext = createContext<DateContextType | undefined>(
    undefined,
);

export function useDateContext() {
    const context = useContext(DateContext);
    if (!context) {
        throw new Error('useDateContext must be used within DateProvider');
    }
    return context;
}
